import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";

export default class CustomButton extends Component {
  clicked() {
    if (!this.props.loading && !this.props.disabled) this.props.onClick();
  }
  render() {
    if (this.props.direction === "vertical") {
      return (
        <div className="customButtonContainer">
          <div
            className="customButtonVertical"
            style={{
              backgroundColor:
                this.props.backColor !== undefined &&
                this.props.backColor !== null
                  ? this.props.backColor
                  : "var(--brown1)",
              height:
                this.props.height !== undefined ? this.props.height : "unset",
              width:
                this.props.width !== undefined ? this.props.width : "unset",
            }}
            onClick={this.clicked.bind(this)}
          >
            {this.props.img !== undefined && this.props.img !== null && (
              <div className="customButtonImg">
                <img
                  src={this.props.img}
                  style={{ width: "80%", height: "80%", objectFit: "contain" }}
                  alt=""
                />
              </div>
            )}

            {this.props.ico && <Icon icon={this.props.ico} />}
            {this.props.title !== undefined &&
              this.props.title !== null &&
              this.props.title !== "" && (
                <div className="customButtonTitle">{this.props.title}</div>
              )}
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="customButtonContainer"
          style={{
            width: this.props.width !== undefined ? this.props.width : "unset",
          }}
        >
          <div
            className="customButton"
            style={{
              justifyContent:
                this.props.justifyContent !== undefined
                  ? this.props.justifyContent
                  : "center",
              backgroundColor:
                this.props.backColor !== undefined &&
                this.props.backColor !== null
                  ? this.props.backColor
                  : "var(--brown1)",
              flexDirection:
                this.props.flexDirection !== undefined
                  ? this.props.flexDirection
                  : "row",
              minHeight:
                this.props.minHeight !== undefined
                  ? this.props.minHeight
                  : "35px",
              minWidth:
                this.props.minWidth !== undefined
                  ? this.props.minWidth
                  : "unset",
            }}
            onClick={this.clicked.bind(this)}
          >
            {!this.props.loading &&
              this.props.title !== undefined &&
              this.props.title !== null &&
              this.props.title !== "" && (
                <div
                  style={{
                    flex:
                      this.props.titleFlex !== undefined
                        ? this.props.titleFlex
                        : "1",
                    fontFamily:
                      this.props.fontFamily !== undefined
                        ? this.props.fontFamily
                        : "SFUIDisplayBold",
                    fontSize:
                      this.props.fontSize !== undefined
                        ? this.props.fontSize
                        : "14px",
                    whiteSpace:
                      this.props.whiteSpace !== undefined
                        ? this.props.whiteSpace
                        : "unset",
                  }}
                >
                  {this.props.title}
                </div>
              )}
            {!this.props.loading &&
              this.props.img !== undefined &&
              this.props.img !== null && (
                <div
                  style={{
                    width:
                      this.props.imgWidth !== undefined
                        ? this.props.imgWidth
                        : "18px",
                    height:
                      this.props.imgHeight !== undefined
                        ? this.props.imgHeight
                        : "18px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight:
                      this.props.imgMarginRight !== undefined
                        ? this.props.imgMarginRight
                        : "0px",
                    marginLeft:
                      this.props.imgMarginLeft !== undefined
                        ? this.props.imgMarginLeft
                        : "0px",
                  }}
                >
                  <img
                    src={this.props.img}
                    style={{
                      width: "80%",
                      height: "80%",
                      objectFit: "contain",
                      transform:
                        this.props.imgRotate !== undefined
                          ? "rotate(" + this.props.imgRotate + "deg)"
                          : "rotate(0deg)",
                    }}
                    alt=""
                  />
                </div>
              )}

            {!this.props.loading && this.props.ico && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight:
                    this.props.icoMarginRight !== undefined
                      ? this.props.icoMarginRight
                      : "0px",
                  marginLeft:
                    this.props.icoMarginLeft !== undefined
                      ? this.props.icoMarginLeft
                      : "0px",
                }}
              >
                <Icon
                  icon={this.props.ico}
                  width={this.props.icoWidth ? this.props.icoWidth : "20"}
                  height={this.props.icoHeight ? this.props.icoHeight : "20"}
                />
              </div>
            )}
            {this.props.loading && (
              <Spinner
                style={{
                  color: "white",
                  height:
                    this.props.loadingHeight !== undefined
                      ? this.props.loadingHeight
                      : "20px",
                  width:
                    this.props.loadingWidth !== undefined
                      ? this.props.loadingWidth
                      : "20px",
                }}
                animation="border"
              />
            )}
          </div>
        </div>
      );
    }
  }
}
